const headerTemplate = `<!DOCTYPE html>
<html>
  <body>
    <div id="appraisalHeader">
    <div><p>Appraisal&nbsp; For : &nbsp; {{investmentId }}&nbsp;-&nbsp;{{investmentName}}</p></div>
    <div><p>Appraisal&nbsp; Type : &nbsp; {{appraisalType}}</p></div>
    
    </div>
  </body>
</html>`;

export default headerTemplate;
